<div name="menu" collapsiblesidebar="bs-gt-xl" overlayclass="sidenav-overlay"
  class="main-menu menu-fixed menu-accordio menu-shadow ng-star-inserted menu-light expanded" style="width:100%;">
  <div menutype="vertical-menu" class="vertical-menu">

    <div class="ng-star-inserted">
      <div class="navbar-header ">
        <ul class="nav navbar-nav flex-row">
          <li class="nav-item mr-auto">
            <a class="navbar-brand" [routerLink]="[this.sesion.generateUrl('/')]" title="ChilePasajes.cl">

              <h2 class="brand-text mb-0">#chilepasajes</h2>
            </a>
          </li>
          <li class="nav-item nav-toggle" (click)="accion()">
            <a class="nav-link modern-nav-toggle d-none d-xl-block pr-0"><i
            class="toggle-icon feather font-medium-4 collapse-toggle-icon text-primary icon-disc"></i></a>
            <a class="nav-link modern-nav-toggle d-block d-xl-none pr-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-x font-medium-4 text-primary toggle-icon">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </a>
          </li>
        </ul>
      </div>
      <div class="main-menu-content" style="
        overflow-y: scroll;
        /* width: 200px; */
        height: 600px !important;
        overflow-y: scroll;
    ">
        @if (sesion.user) {
          <ul class="navigation navigation-main mt-0 d-none" id="main-menu-navigation"
            data-menu="menu-navigation" style="background-color: #e6ebef;">
            <li class="navigation-header mt-1"><span data-i18n="Misc">{{'menu.miCuenta' | translate}}</span><svg
            class="feather feather-more-horizontal" fill="none" height="14" stroke="currentColor"
            stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="14"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="1"></circle>
            <circle cx="19" cy="12" r="1"></circle>
            <circle cx="5" cy="12" r="1"></circle>
          </svg></li>
          <li [ngClass]="{'active': step == 'mi-cuenta'}">
            <a class="nav-item" (click)="ir('/cuenta/perfil')" title="Mi cuenta">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-user">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              {{'menu.miCuenta' | translate}}</a>
          </li>
          <li [ngClass]="{'active': step == 'viajes'}">
            <a class="nav-item" (click)="ir('/cuenta/viajes')" title="Viajes">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-bookmark">
                <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
              </svg>
              {{'menu.viajes' | translate}}</a>
          </li>
          <li [ngClass]="{'active': step == 'cupones'}">
            <a class="nav-item" (click)="ir('/cuenta/cupones')" title="Cupones">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-gift">
                <polyline points="20 12 20 22 4 22 4 12"></polyline>
                <rect x="2" y="7" width="20" height="5"></rect>
                <line x1="12" y1="22" x2="12" y2="7"></line>
                <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
                <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
              </svg>
              {{'menu.puntos' | translate}}</a>
          </li>
          <li [ngClass]="{'active': step == 'mis-viajeros'}">
            <a class="nav-item" (click)="ir('/cuenta/pasajeros')" title="Pasajeros">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-users">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
              {{'menu.misViajeros' | translate}}</a>
          </li>
          <li [ngClass]="{'active': step == 'anulaciones'}">
            <a class="nav-item" (click)="ir('/cuenta/cancelaciones')" title="Anulaciones">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-zap">
                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
              </svg>
              {{'menu.gestionBoleto' | translate}} </a>
          </li>
        </ul>
      }
      <ul class="navigation navigation-main" data-menu="menu-navigation" id="main-menu-navigation">
        <li class="navigation-header"><span data-i18n="Que Buscas?">{{'menu.que_buscas' | translate}}</span></li>
        <li class="nav-item active" (click)="accion()"><a class="d-flex align-items-center" title="ir al buscador de pasajes" [routerLink]="['/' + this.lang + '/bus']"><svg
          xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" class="iconify iconify--fe" height="1em"
          id="footer-sample-full" preserveAspectRatio="xMidYMid meet" role="img" viewBox="0 0 24 24" width="1em"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16 19H8a2 2 0 1 1-4 0V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v14a2 2 0 1 1-4 0Zm1-4a1 1 0 1 0 0-2a1 1 0 0 0 0 2ZM7 15a1 1 0 1 0 0-2a1 1 0 0 0 0 2ZM6 5v6h12V5H6Z"
          fill="currentColor"></path>
          </svg><span class="menu-title text-truncate" data-i18n="Email">{{'menu.buses' | translate}} </span></a></li>
          <!-- <li class="nav-item active" (click)="accion()"><a class="d-flex align-items-center" title="ir al buscador de transfer" [routerLink]="['/' + this.lang + '/transfer']"><svg
            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="m20.772 10.155l-1.368-4.104A2.995 2.995 0 0 0 16.559 4H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.104A2 2 0 0 0 2 12v5c0 .738.404 1.376 1 1.723V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h12v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.277A1.99 1.99 0 0 0 22 17v-5a2 2 0 0 0-1.228-1.845zM7.441 6h9.117c.431 0 .813.274.949.684L18.613 10H5.387l1.105-3.316A1 1 0 0 1 7.441 6zM5.5 16a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5.5 16zm13 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18.5 16z" />
              </svg><span class="menu-title text-truncate" data-i18n="Email">Transfer </span></a></li> -->
            </ul>
            <ul class="navigation navigation-main pt-0">
              <li class="navigation-header mt-1"><span data-i18n="Información">{{'menu.informacion' | translate}}</span></li>
              <li class="nav-item" (click)="accion()"><a class="d-flex align-items-center fs-14 hv-30" title="Servicio al cliente"
                [routerLink]="['/' + this.lang + '/ayuda']"><svg class="feather feather-help-circle" fill="none" height="24" stroke="currentColor"
                stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
                xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                <line x1="12" x2="12.01" y1="17" y2="17"></line>
                </svg><span class="menu-title text-truncate" data-i18n="Email">{{'menu.servicioCliente' | translate}} </span></a></li>
                <li class="nav-item" (click)="accion()"><a class="d-flex align-items-center fs-14 hv-30" title="Gestiona tus boletos: anula, cambia, cambia paradero, etc."
                  [routerLink]="['/' + this.lang + '/gestion-boletos']"><svg class="feather feather-minus-circle" fill="none" height="24"
                  stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="8" x2="16" y1="12" y2="12"></line>
                  </svg><span class="menu-title text-truncate" data-i18n="Email">{{'menu.gestionBoleto' | translate}}</span></a></li>
                  @if (checkComplLogin) {
                    <li class="nav-item" (click)="accion()"><a class="d-flex align-items-center fs-14 hv-30" title="Lista completa de todas las páginas de chilepasajes.cl"
                      [routerLink]="['/' + this.lang + '/mapa-del-sitio']"><svg class="feather feather-git-pull-request" fill="none" height="24"
                      stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="18" cy="18" r="3"></circle>
                      <circle cx="6" cy="6" r="3"></circle>
                      <path d="M13 6h3a2 2 0 0 1 2 2v7"></path>
                      <line x1="6" x2="6" y1="9" y2="21"></line>
                      </svg><span class="menu-title text-truncate" data-i18n="Email">{{'menu.mapaSitio' | translate}}</span></a></li>
                    }
                    <li class="nav-item" (click)="accion()"><a class="d-flex align-items-center fs-14 hv-30" title="Lea los Términos y Condiciones de uso del sitio"
                      [routerLink]="['/' + this.lang + '/terminos-y-condiciones']"><svg class="feather feather-file-text" fill="none" height="24"
                      stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                      <polyline points="14 2 14 8 20 8"></polyline>
                      <line x1="16" x2="8" y1="13" y2="13"></line>
                      <line x1="16" x2="8" y1="17" y2="17"></line>
                      <polyline points="10 9 9 9 8 9"></polyline>
                      </svg><span class="menu-title text-truncate" data-i18n="Email">{{'menu.termCondiciones' | translate}}</span></a></li>
                      <li class="nav-item" (click)="accion()"><a class="d-flex align-items-center fs-14 hv-30" title="Lea las Politicas de privacidad del sitio"
                        [routerLink]="['/' + this.lang + '/politicas-privacidad']"><svg class="feather feather-shield" fill="none" height="24"
                        stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                        </svg><span class="menu-item text-truncate" data-i18n="Badges">{{'menu.poliPrivacidad' | translate}}</span></a></li>
                        <li class="nav-item" (click)="accion()"><a class="d-flex align-items-center fs-14 hv-30" title="Lea las Politicas de cookies del sitio"
                          [routerLink]="['/' + this.lang + '/politicas-cookies']"><svg class="feather feather-pocket" fill="none" height="24"
                          stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"></path>
                          <polyline points="8 10 12 14 16 10"></polyline>
                          </svg><span class="menu-item text-truncate" data-i18n="Badges">{{'menu.poliCookies' | translate}}</span></a></li>
                          <!---->
                          <li class="navigation-header"><span data-i18n="Misc">{{'menu.siguenos' | translate}} </span><svg
                          class="feather feather-more-horizontal" fill="none" height="14" stroke="currentColor"
                          stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="14"
                          xmlns="http://www.w3.org/2000/svg">
                          <circle cx="12" cy="12" r="1"></circle>
                          <circle cx="19" cy="12" r="1"></circle>
                          <circle cx="5" cy="12" r="1"></circle>
                        </svg></li>
                        <!---->
                        <li class="navigation-header mt-1">
                          <div class="col-lg-12 col-12">
                            <div aria-label="Basic example" class="btn-group" role="group"><button (click)="irFacebook()"
                              class="btn btn-outline-primary waves-effect" title="Ir a la página de Facebook de ChilePasajes" type="button"><svg
                              class="feather feather-facebook" fill="none" height="14" stroke="currentColor"
                              stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="14"
                              xmlns="http://www.w3.org/2000/svg">
                              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                            </svg></button><button (click)="irTwiter()" class="btn btn-outline-primary waves-effect" title="Ir a la página de Twitter de ChilePasajes" type="button"><svg
                            class="feather feather-twitter" fill="none" height="14" stroke="currentColor" stroke-linecap="round"
                            stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="14"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z">
                            </path>
                          </svg></button><button (click)="irInstagram()" class="btn btn-outline-primary waves-effect" title="Ir a la página de Instagram de ChilePasajes"
                          type="button"><svg class="feather feather-instagram" fill="none" height="14" stroke="currentColor"
                          stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="14"
                          xmlns="http://www.w3.org/2000/svg">
                          <rect height="20" rx="5" ry="5" width="20" x="2" y="2"></rect>
                          <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                          <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"></line>
                        </svg></button></div>
                      </div>
                    </li>
                  </ul>

                </div>
              </div>
